import { MapPin } from 'lucide-react';
import { DetailListItem } from '../../components/ui/detail-list-item';

export { normalizeWebsiteUrl } from '../../components/ui/detail-list-item';

export interface OrganizationDetailListItemProps {
  org: {
    id: string;
    name: string;
    slug?: string;
    description?: string | null;
    website?: string | null;
    organizationType?: { label?: string } | null;
    province?: { name?: string; code?: string } | null;
    city?: { name?: string } | null;
    cityName?: string | null;
    provinceCode?: string | null;
    address?: string | null;
  };
  onSelect: () => void;
  className?: string;
  descriptionLines?: number;
}

export function OrganizationDetailListItem({
  org,
  onSelect,
  className,
  descriptionLines = 4,
}: OrganizationDetailListItemProps) {
  const locationLabel = [org.city?.name ?? org.cityName, org.province?.code ?? org.province?.name ?? org.provinceCode]
    .filter(Boolean)
    .join(', ');

  const meta =
    org.organizationType?.label || locationLabel ? (
      <>
        {org.organizationType?.label && <span>{org.organizationType.label}</span>}
        {locationLabel && (
          <span className="inline-flex items-center gap-1">
            <MapPin className="w-3 h-3 flex-shrink-0" />
            {locationLabel}
          </span>
        )}
      </>
    ) : undefined;

  return (
    <DetailListItem
      title={org.name}
      description={org.description}
      website={org.website}
      meta={meta}
      onSelect={onSelect}
      className={className}
      descriptionLines={descriptionLines}
    />
  );
}
